module.exports = __webpack_public_path__ + "img/beincrypto.0be7a99c.png";